import React, { createContext } from 'react';
import useFilter from 'hooks/useFilter';

const FilterContext = createContext();

function FilterProvider({ children, data }) {
	const { filterData, setFilterData } = useFilter(data);

	return (
		<FilterContext.Provider value={{ filterData, setFilterData }}>
			{children}
		</FilterContext.Provider>
	);
}

export { FilterContext, FilterProvider };
